export default __webpack_public_path__ + "static/media/logo2.68e9f619.png";